import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home';
import Albums from './pages/albums';
import AlbumDetail from './pages/albumDetail';
import Artists from './pages/artists';
import ArtistDetail from './pages/artistDetail';
import Playlists from './pages/playlists';
import Songs from './pages/songs';
import PlaylistDetail from './pages/playlistDetail';
import Auth from './pages/Auth';
import { RequireAuth } from './components/routing/RequireAuth';
import { Layout } from './components/PageComponents/Layout';
import './theme.css';
import './App.css';

function App(): React.JSX.Element {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Auth />} />
                <Route path="/register" element={<Auth />} />
                <Route
                    element={
                        <RequireAuth>
                            <Layout />
                        </RequireAuth>
                    }
                >
                    <Route path="/home" element={<Home />} />
                    <Route path="/albums" element={<Albums />} />
                    <Route path="/albums/:id" element={<AlbumDetail />} />
                    <Route path="/artists" element={<Artists />} />
                    <Route path="/artists/:id" element={<ArtistDetail />} />
                    <Route path="/songs" element={<Songs />} />
                    <Route path="/playlists" element={<Playlists />} />
                    <Route path="/playlists/:id" element={<PlaylistDetail />} />
                </Route>

                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
